var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noticesContentList.length > 0
    ? _c(
        "el-carousel",
        {
          staticClass: "u-m-l-15 u-m-r-15 u-m-b-10",
          attrs: {
            interval: 5000,
            arrow: "never",
            direction: "vertical",
            height: "40px",
            "indicator-position": "none",
          },
        },
        _vm._l(_vm.noticesContentList, function (itemData, index) {
          return _c(
            "el-carousel-item",
            { key: index },
            [
              _c("el-alert", {
                attrs: { closable: false, type: "info" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "u-flex u-font-weight-bold u-font-18",
                              staticStyle: { color: "#303133" },
                            },
                            [
                              _vm._l(
                                itemData.contentList,
                                function (itemContent, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticClass: "u-m-r-5",
                                      class: itemContent.includes("red")
                                        ? "u-color-red"
                                        : "",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            itemContent.replace("red", "")
                                          ) +
                                          "\n\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _c(
                                "div",
                                { staticClass: "u-m-l-20" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "u-font-weight-bold u-font-18",
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onToDealHint(itemData)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(itemData.btnContent) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }